export default __webpack_public_path__ + "static/media/JLT4.5539b39c.webp";